import { createClient } from '@supabase/supabase-js'
import { useQuery } from '@tanstack/react-query'

const supabase = createClient(
  process.env.NEXT_PUBLIC_SUPABASE_URL_CORE!,
  process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY_CORE!
)

// local_id           Int      @id
// buildable_area     Int
// left               Int
// top                Int
// right              Int
// bottom             Int
// biome              String
// region_display_tag String
// revealed           Boolean  @default(false)
// id                 Decimal? @db.Decimal // nft contract id
// global_id          Decimal? @db.Decimal

export async function getPlots() {
  const { data, error } = await supabase
    .from('plots')
    .select(
      'id::text,local_id,buildable_area,left,right,top,bottom,biome,region_display_tag'
    ) // note our project allows all land plots to return

  if (error) {
    console.error(error)
    return []
  }

  // find local_id 4573 and print out the rest of the data
  const plot = data.find((plot) => plot.local_id === 4573)
  // console.log("4573", plot)

  return data.map((plot) => ({
    local_id: plot.local_id,
    buildable_area: plot.buildable_area,
    position: {
      left: plot.left,
      top: plot.top,
      right: plot.right,
      bottom: plot.bottom,
    },
    biome: plot.biome,
    region_display_tag: plot.region_display_tag,
    id: plot.id,
  }))
}

export async function getPlotsWithinSquare(
  top: number,
  left: number,
  bottom: number,
  right: number
) {
  const { data, error } = await supabase
    .from('plots')
    .select('*')
    .gte('top', top)
    .lte('bottom', bottom)
    .gte('left', left)
    .lte('right', right)
  if (error) {
    console.error(error)
    return []
  }

  return data.map((plot) => ({
    local_id: plot.local_id,
    buildable_area: plot.buildable_area,
    position: {
      left: plot.left,
      top: plot.top,
      right: plot.right,
      bottom: plot.bottom,
    },
    biome: plot.biome,
    region_display_tag: plot.region_display_tag,
    id: plot.id,
  }))
}

export async function useAllPlots() {
  return useQuery({
    queryKey: ['plots'],
    queryFn: getPlots,
  })
}

export async function usePlotsWithinSquare(
  top: number,
  left: number,
  bottom: number,
  right: number
) {
  return useQuery({
    queryKey: ['plots', top, left, bottom, right],
    queryFn: () => getPlotsWithinSquare(top, left, bottom, right),
  })
}
